/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  display: block; }\n\n.toast-container[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0;\n  padding: 1.5em 1.5em;\n  transition: 0.3s ease;\n  bottom: -5em; }\n\n.toast-wrapper[_ngcontent-%COMP%] {\n  transition: 0.3s ease;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  background: white; }\n\n.toast-wrapper[_ngcontent-%COMP%]    + .toast-wrapper[_ngcontent-%COMP%] {\n  margin-top: 1em; }"];
export { styles as styles };
